import tgAxios from "@/api/api-axios";
import { ApiResponse } from "@/types/app.type";
import { ListResponse } from "@/types/app.type";
import { CreateUserPayload, User, Permission, UserFilter, UserType, UserStatus } from "../types/user.type";
export const getUserMe = () => {
  return tgAxios.get("/user");
};
export const changePassword = (
  currentPassword: string,
  newPassword: string,
  confirmPassword: string
) => {
  return tgAxios.post("/user/change-password", {
    currentPassword,
    confirmPassword,
    newPassword,
  });
};

export interface UpdateUserProfilePayload {
  fullName?: string;
  phone?: string;
  email?: string;
}

export const updateUserProfile = (
  data: UpdateUserProfilePayload
): Promise<ApiResponse<unknown>> => {
  return tgAxios.put(`/user`, data);
};

export const getUserList = (
  params: UserFilter
): Promise<ListResponse<User>> => {
  const queryString = new URLSearchParams();

  if (params.page) queryString.set("page", params.page.toString());
  if (params.pageSize) queryString.set("pageSize", params.pageSize.toString());
  if (params.fullName) queryString.set("fullName", params.fullName);
  if (params.keyword) queryString.set("keyword", params.keyword);
  if (params.status && params.status !== "all") queryString.set("status", params.status);
  if (params.email) queryString.set("email", params.email);
  return tgAxios.get(`/user/list?${queryString.toString()}`);
};
export const createUser = (data: CreateUserPayload): Promise<ApiResponse<unknown>> => {
  return tgAxios.post(`/user`, data);
};
export const lockUser = (id: string): Promise<ApiResponse<unknown>> => {
  return tgAxios.put(`/user/${id}`, { status: "inactive" });
};
export const unlockUser = (id: string): Promise<ApiResponse<unknown>> => {
  return tgAxios.put(`/user/${id}`, { status: "active" });
};
export const deleteUser = (id: string): Promise<ApiResponse<unknown>> => {
  return tgAxios.delete(`/user/${id}`);
};
export const getUserById = (id: string): Promise<ApiResponse<unknown>> => {
  return tgAxios.get(`/user/profile/${id}`);
};

export interface UpdateUserPayload {
  fullName?: string;
  email?: string;
  phone?: string;
  password?: string;
  permissionIds?: string[];
  devices?: string[];
  rooms?: string[];
  status?: UserStatus;
  type?: UserType;
}

export const updateUser = (
  id: string,
  data: UpdateUserPayload
): Promise<ApiResponse<unknown>> => {
  return tgAxios.put(`/user/${id}`, data);
};
export const getPermissionList = (): Promise<ApiResponse<Permission[]>> => {
  return tgAxios.get(`/user/permissions`);
};